import CoachOffboarding from './CoachOffboarding';

export default CoachOffboarding;
